// Mock data for cellrox iPhone repair website

export const mockServices = [
  {
    id: 1,
    name: "Screen Replacement",
    description: "Cracked or shattered screen? We'll have it looking brand new.",
    icon: "Smartphone",
    models: [
      { model: "iPhone 15 Pro Max", price: 449, time: "45 min" },
      { model: "iPhone 15 Pro", price: 429, time: "45 min" },
      { model: "iPhone 15", price: 379, time: "40 min" },
      { model: "iPhone 14 Pro Max", price: 399, time: "40 min" },
      { model: "iPhone 14", price: 349, time: "35 min" },
      { model: "iPhone 13", price: 299, time: "30 min" },
      { model: "iPhone 12", price: 279, time: "30 min" },
      { model: "iPhone 11", price: 229, time: "25 min" },
    ]
  },
  {
    id: 2,
    name: "Battery Replacement",
    description: "Phone dying too fast? Get a fresh battery installed today.",
    icon: "Battery",
    models: [
      { model: "iPhone 15 Series", price: 119, time: "30 min" },
      { model: "iPhone 14 Series", price: 109, time: "30 min" },
      { model: "iPhone 13 Series", price: 99, time: "25 min" },
      { model: "iPhone 12 Series", price: 89, time: "25 min" },
      { model: "iPhone 11 Series", price: 79, time: "20 min" },
      { model: "iPhone X/XS/XR", price: 69, time: "20 min" },
    ]
  },
  {
    id: 3,
    name: "Charging Port Repair",
    description: "Having trouble charging? We fix charging port issues quickly.",
    icon: "Cable",
    price: 79,
    time: "30-45 min"
  },
  {
    id: 4,
    name: "Camera Repair",
    description: "Blurry or broken camera? Get it fixed professionally.",
    icon: "Camera",
    price: 119,
    time: "35-50 min"
  },
  {
    id: 5,
    name: "Water Damage Repair",
    description: "Dropped in water? We offer comprehensive water damage restoration.",
    icon: "Droplets",
    price: 149,
    time: "1-2 hours"
  },
  {
    id: 6,
    name: "Back Glass Replacement",
    description: "Shattered back glass? We'll restore your phone's appearance.",
    icon: "Tablet",
    price: 129,
    time: "45-60 min"
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    rating: 5,
    comment: "Fast, professional service! My iPhone screen was replaced in 30 minutes. Looks perfect!",
    date: "2 weeks ago",
    service: "Screen Replacement"
  },
  {
    id: 2,
    name: "Michael Chen",
    rating: 5,
    comment: "Best repair shop in Mississauga! Battery replacement was quick and affordable. Highly recommend!",
    date: "1 month ago",
    service: "Battery Replacement"
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    rating: 5,
    comment: "Saved my water-damaged iPhone! Excellent service and very knowledgeable staff.",
    date: "3 weeks ago",
    service: "Water Damage Repair"
  },
  {
    id: 4,
    name: "David Thompson",
    rating: 5,
    comment: "Convenient location inside Walmart. Fixed my charging port while I shopped. Perfect!",
    date: "1 week ago",
    service: "Charging Port Repair"
  }
];

export const mockGallery = [
  {
    id: 1,
    before: "https://images.unsplash.com/photo-1565106430482-8f6e74349ca1?w=400",
    after: "https://images.unsplash.com/photo-1550041473-d296a3a8a18a?w=400",
    description: "iPhone 14 Pro Screen Replacement"
  },
  {
    id: 2,
    before: "https://images.unsplash.com/photo-1603006905003-be475563bc59?w=400",
    after: "https://images.unsplash.com/photo-1735875530804-d661ca2001da?w=400",
    description: "iPhone 13 Battery Replacement"
  },
  {
    id: 3,
    before: "https://images.unsplash.com/photo-1601784551446-20c9e07cdbdb?w=400",
    after: "https://images.unsplash.com/photo-1746005718004-1f992c399428?w=400",
    description: "iPhone 12 Camera Repair"
  }
];

export const mockFAQs = [
  {
    id: 1,
    question: "How long does a typical repair take?",
    answer: "Most repairs are completed within 30-60 minutes. Complex repairs like water damage may take 1-2 hours. We'll give you an accurate time estimate when you arrive."
  },
  {
    id: 2,
    question: "Do you offer a warranty on repairs?",
    answer: "Yes! All our repairs come with a 90-day warranty covering parts and labor. If you experience any issues, bring it back and we'll fix it free of charge."
  },
  {
    id: 3,
    question: "Do I need an appointment?",
    answer: "Walk-ins are welcome! However, booking an appointment ensures we're ready for you and minimizes wait time."
  },
  {
    id: 4,
    question: "What payment methods do you accept?",
    answer: "We accept cash, credit cards (Visa, Mastercard, Amex), debit cards, and e-transfers."
  },
  {
    id: 5,
    question: "Are your parts genuine Apple parts?",
    answer: "We use high-quality OEM (Original Equipment Manufacturer) parts that meet or exceed Apple's standards. All parts are thoroughly tested before installation."
  }
];

export const mockBookingSlots = [
  "9:00 AM", "10:00 AM", "11:00 AM", "12:00 PM",
  "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM",
  "5:00 PM", "6:00 PM", "7:00 PM", "8:00 PM"
];

export const chatbotResponses = {
  greeting: "Hello! I'm here to help with your iPhone repair needs. How can I assist you today?",
  services: "We offer screen replacement, battery replacement, charging port repair, camera repair, water damage restoration, and back glass replacement. Which service are you interested in?",
  pricing: "We offer competitive pricing for all repairs. Visit us at 800 Matheson Blvd West or call 905-699-6599 for a free quote on your specific device!",
  booking: "I can help you book an appointment! We're open Monday-Sunday, 9 AM - 9 PM. What date works best for you?"
};
